module.exports = require("@angular/common");


//////////////////
// WEBPACK FOOTER
// external "@angular/common"
// module id = 59
// module chunks = 0